// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".telechargement[data-v-66b09b0a]{width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;display:flex;align-items:center;border-radius:25px;padding:8px}@media(max-width:768px){.telechargement[data-v-66b09b0a]{width:100%}}@media(max-width:768px){.telechargement__texte[data-v-66b09b0a]{display:flex;flex-wrap:wrap}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
